module.exports = "/images/pg.svg?7b509a370bb426cc58315c7d38ed1710";